// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-AboutHeader----AboutHeader-module---header---1n4kS","headerAbout":"src-components-AboutHeader----AboutHeader-module---headerAbout---3oSC8","headerPhoto":"src-components-AboutHeader----AboutHeader-module---headerPhoto---3Nz_J","headerCaption":"src-components-AboutHeader----AboutHeader-module---headerCaption---3Sv-J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutHeader/AboutHeader.module.scss
// module id = 933
// module chunks = 144251824217401